$(".membership-choice-extra-info #membership_form").submit(function(e){
	e.preventDefault();
	$("#membership_form .membership-choice-next").attr('disabled', 'disabled');
	var _ = this;
	//e.preventDefault();
	if($(".membership-choice-welleasy.active[data-selling-plan-id]").length > 0){
		$(".membership-choice-extra-info #membership_form input[name='selling_plan']").val($(".membership-choice-welleasy.active").attr('data-selling-plan-id'))
	}else{
		$(".membership-choice-extra-info #membership_form input[name='selling_plan']").val('');
	}
	$.ajax({
		type: 'GET',
		url: '/cart.js',
		dataType: 'json',
		success: function (data) {
			if(data.item_count > 0){
				var dataItem = data.items;
				addRemoveMembershipsCheckout(dataItem, 0);
			}else{
				$(".membership-choice-extra-info #membership_form").unbind().submit();
			}

		},
	});

	$("#membership_form .membership-choice-next").removeAttribute('disabled');
	$("#membership_form .membership-choice-next").click(function(){
		$(this).attr('disabled', 'disabled');
	});
});

// START code == Membership details hide/show in cart page //
function slideDown( element, duration ) 
{
	element.style.transition = 'height ' + duration + 'ms ease';
	element.style.height = element.scrollHeight + 'px';
}

function slideUp( element, duration ) 
{
	element.style.transition = 'height ' + duration + 'ms ease';
	element.style.height = 0;  // Remove 'px'
}

function toggleMembershipDetails() 
{
	
	var seeless_button = document.querySelector( '.seeless_button' );
	var seemore_button = document.querySelector( '.seemore_button' );
	var membership_benefits = document.querySelector( '.lightning-membership-product-cartpage .membership_benefits' );

	if ( seeless_button ) 
	{
		
		seeless_button.addEventListener( 'click', function () 
		{
			slideUp( membership_benefits, 300 );
			seeless_button.style.display = 'none';
			seemore_button.style.display = 'inline-block';
			
		});
	}
	if ( seemore_button ) 
	{
		seemore_button.addEventListener( 'click', function () 
		{
			slideDown( membership_benefits, 300 );
			seemore_button.style.display = 'none';
			seeless_button.style.display = 'inline-block';
			
		});
	}
}
// END code == Membership details hide/show in cart page //
// setTimeout(function () {

	var collection_observer = '';
	var chagine_event_welleasy = false;

	document.querySelector( ".site-header__cart-trigger, .cart-drawer__content .close-cart__trigger" ).addEventListener( "click", function( )
	{
		document.body.classList.toggle( "cart-drawer--show" );
	})

	function setUpCartEventsWellEasy(){
		$(".cart-drawer-items-container input[type=number].cart-quantity-value,.snize-search-results-content .snize-product input[type=number].cart-quantity-value").off().click(function(e){
			e.preventDefault();
		});
		$('.cart-quantity').off().click(function(e){
			e.preventDefault();
		});
		$('input.cart-quantity-value').keyup(function(e){
			e.preventDefault();

			var key = e.keyCode || e.charCode;
		    if( key == 8 || key == 46 )
		        return false;
		    chagine_event_welleasy = true;
			var welleasy_input_qty = $(this).val();
			var welleasy_input_line = $(this).data('line');
			var welleasy_input_action='/cart/change?line='+welleasy_input_line+'&quantity='+welleasy_input_qty;
			changeCartWellEasy(welleasy_input_action, e);
		});

		$("[data-ajax-cart-request-button]").off().click(function (e) {
			e.preventDefault();
			var action = $(this).attr('href');
			var $input = $(this).closest('.cart-quantity').find('input.cart-quantity-value');
			var input = e.target.closest( ".cart-quantity" )
			var originalValue = $input.val();

			// Optimistically update the input value for plus/minus buttons
			if ($(this).data('type') === 'plus') {
				$input.val(Number(originalValue) + 1);
			} else if ($(this).data('type') === 'minus') {
				$input.val(Math.max(Number(originalValue) - 1, 1));
			}

			if ($(this).attr('title') == 'Remove'){
				if (action.includes('change')) {
					changeCartWellEasy(action, e);
				}
			}else if (checkProductInventoryWellEasy(e.currentTarget)){
				if (action.includes('change')) {
					changeCartWellEasy(action, e);
					input.querySelector( ".qty-spinner" ).classList.remove( "hidden" );
					input.querySelectorAll( ".cart-quantity-value-change" ).forEach( el => el.classList.add( "disabled" ) );
					input.querySelector( ".cart-quantity-value" ).disabled = true;
				}
			}

			// If AJAX fails, revert the value (optional: handle in error callback of changeCartWellEasy)
		});

		if ( !document.querySelector( ".cart-drawer__content .close-cart__trigger" ).dataset.listenerAttached )
		{
			document.querySelector( ".cart-drawer__content .close-cart__trigger" ).dataset.listenerAttached = true;
			document.querySelector( ".cart-drawer__content .close-cart__trigger" ).addEventListener( "click", function( )
			{
				document.body.classList.toggle( "cart-drawer--show" );
			})
		}

		$("[data-ajax-cart-request-button-new]").off().click(function(e){
			e.preventDefault();
			var action = $(this).attr('href');

			if( !action )
			{
				action = this.getAttribute( "data-action" );
			}

			if( this.getAttribute( "title" ) == "selling_plan" )
			{
				//adding to the beast that is the code to handle cart updates... no time to re write but something to be looked at
				changeCartWellEasy(action, e);
			}
			else if (checkProductInventoryWellEasy(e.currentTarget)) 
			{
				if (action.includes('change')) {
					changeCartWellEasy(action);
				}
			}
		});
		

		$(".add-to-cart-new").off().click(function(e){
			
			e.preventDefault(); 
			if($(".main-wishlist .wishlist-container").length > 0){
				var product_id = $(this).parents('.wishlist-container').find(".lightning-wishlist-control").attr('data-product');
			} else {
				var product_id = $(this).parents('li.snize-product').attr('id');
				if (product_id) 
				{
					if( product_id.includes("snize-product-") )
					{
						product_id = product_id.replace("snize-product-","");					
					}
				}
				else
				{
					var product_id = $(this).parents('.we-product-card-wrapper').attr('id');
					product_id = product_id.replace("snize-product-","");					
				}
			}
			var variant_id = getVariantFromProductID(window.BOLD.common.Shopify.variants,product_id);
			$(this).addClass('loading');
			if(variant_id <= 0){
				if($(".main-wishlist .wishlist-container").length > 0){
					var product_handle = $(this).parents(".wishlist-container").find("[data-wishlist-anchor]").attr('href');
				} else {
					var product_handle = $(this).parents("a.snize-view-link").attr('href');
				}
				if(!product_handle)
				{
					var product_handle = $(this).parents(".we-product-card-wrapper").find(".we-product-card-link").attr("href");
				}
				if(product_handle){
					product_handle = product_handle.split("/products/").pop();
					$.getJSON(window.Shopify.routes.root+'products/'+product_handle+'.json',function(result){
						if(result){
							addCartWellEasy('id='+result.product.variants[0].id+'&quantity=1');
						}
					});
				}
			}else{
				addCartWellEasy('id='+variant_id+'&quantity=1');
			}

		});
		$(".not-in-cart.snize-product input.cart-quantity-value").each(function(){
			if($(this).val() == $(this).data('max')){
				$(this).parents('.cart-quantity').find('.cart-quantity-value-change[data-type="plus"]').addClass('disabled');
			}
		});


    	/* Order History Add to cart Button add */
		setTimeout(function(){
			$(".order-history-addToCart").off().click(function(e){
					e.preventDefault();
				// console.log(new Date());
					$(this).addClass('loading');
					var order_variant_id = $(this).attr("data-variant-id");
					if (order_variant_id) {
					var qtyVal = "1";
					var parent = $( this ).closest( ".product-row" );
					if( parent )
					{
						parent = parent[ 0 ];
						if( parent )
						{
							var qty = parent.querySelector( ".quantity__input" );
							if( qty )
							{
								qtyVal = qty.value;
							}
						}
					}
						addCartWellEasy('id='+order_variant_id+'&quantity=' + qtyVal);
							$(".welleasy-responsive-table-row").removeClass("not-in-cart");
									}
									setTimeout(function(){
											$(this).removeClass('loading');
									}, 2000);
							});
		},2000);
	}

	function addRemoveMemberships(arrays, key) {
		if (arrays[key].type == 'remove') {
			var params = {
				type: 'POST',
				url: '/cart/change.js',
				data: 'quantity=0&line=' + arrays[key].line_item + '&sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template',
				dataType: 'json',
				success: function (cart) {
					var cart_count = $('#CartCount').text();
					cart_count = parseInt(cart_count);
					$('#CartCount').text(cart_count + 1);
					updateCartDrawer(cart);
					chagine_event_welleasy = false;
					setUpCartEventsWellEasy();
					updateGridSection();
					orderUpdateGridSection();
					wishlistUpdateGridSection();
					if (arrays.length != key + 1) {
						addRemoveMemberships(arrays, key++)
					}
				},
				error: function (XMLHttpRequest, textStatus) {

				}
			};
			jQuery.ajax(params);
		} else {
			var free_membership = arrays[key].variation_id;
			var free_membership_selling_plan = arrays[key].plan_id;

			var params = {
				type: 'POST',
				url: '/cart/add.js',
				data: 'id=' + free_membership + '&quantity=1&selling_plan=' + free_membership_selling_plan + '&sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template',
				dataType: 'json',
				success: function (cart) {
					var cart_count = $('#CartCount').text();
					cart_count = parseInt(cart_count);
					$('#CartCount').text(cart_count + 1);
					updateCartDrawer(cart);
					chagine_event_welleasy = false;
					setUpCartEventsWellEasy();
					updateGridSection();
					orderUpdateGridSection();
					if (arrays.length != key + 1) {
						addRemoveMemberships(arrays, key++)
					}
					var body_element = document.querySelector("body");
					body_element.classList.add("cart-drawer--show");
				},
				error: function (XMLHttpRequest, textStatus) {

				}
			};
			// console.log(params);
			jQuery.ajax(params);
		}
	}

	function collectIdsOfAutoAddRemoveSubscription() {
		if ($("#cart_membership_item").length > 0) {
			var inputs = [];
			var input_index = 0;
			$("#cart_membership_item input").each(function () {
				inputs[input_index] = {
					"type": ($(this).attr('name') == 'add_membership') ? 'add' : 'remove',
					"variation_id": $(this).val(),
					"plan_id": $(this).attr('data-selling-plan-id'),
					"line_item": $(this).attr('data-lineitem')
				};
				input_index++;
			});
			if(inputs.length){
				setTimeout(function () {
					// auto add Memberships product in login/load 
					 addRemoveMemberships(inputs, 0);
				}, 500);
			}
		}
	}
	collectIdsOfAutoAddRemoveSubscription();
	// NEW FLOW PAGE CTA BUTTON ADD TO CART ( FREE PASS BUTTON/ Membership products )
	
	function freepass_ajax(e) 
	{	
		var free_pass_cta_buttons = document.querySelectorAll( '.free_pass_cta' );
		var inputs = [];
		
		free_pass_cta_buttons.forEach(( free_pass_cta_button ) => 
		{
			free_pass_cta_button.addEventListener( 'click', function() 
			{
				var activate_button_text = free_pass_cta_button.getAttribute( 'data-activate_button_text' );
				var activate_button_text_url = free_pass_cta_button.getAttribute( 'data-activate_button_text_url' );
				var variation_id = free_pass_cta_button.getAttribute( 'data-variation_id' );
				var check = document.querySelector( ".cart-drawer-items-container .we_cart_item[data-variant-id='" + variation_id + "']" );
				
				if ( !check ) 
				{
					var cta_data = 
					{
						'type': free_pass_cta_button.getAttribute( 'data-add_membership' ),
						'variation_id': free_pass_cta_button.getAttribute( 'data-variation_id' ),
						'plan_id': free_pass_cta_button.getAttribute( 'data-selling-plan-id' )
					};					
					inputs.push( cta_data );
					addRemoveMemberships( inputs, 0 );
					  // Change the text of all the buttons
					free_pass_cta_buttons.forEach(( button ) => 
					{
						var anchorTag = document.createElement('a');
						anchorTag.href = '/cart';
						anchorTag.className = 'lightning-cta-button free_pass_cta free_pass_cta_pointer';
						anchorTag.textContent = activate_button_text;
						// Replace the button with the newly created anchor tag
						button.parentNode.replaceChild(anchorTag, button);
					});
				}
				
			});
		});
	}
	freepass_ajax();

	var getVariantFromProductID = function(obj, product_id) {
		var returnKey = -1;
		$.each(obj, function(key, info) {
			if (info.product_id == product_id) {
				returnKey = key;
				return false;
			};
		});
		return returnKey;
	}

	function orderUpdateGridSection(){
		
		$('.welleasy-responsive-table-row').removeClass('not-in-cart');
		$('.welleasy-responsive-table-row:not(.not-in-cart) .order-history-addToCart').show();
		$('.welleasy-responsive-table-row .cart-quantity').hide();
		$('.cart-drawer-items-container .we_cart_item').each(function(){
			var order_cart_variant_id = $(this).attr('data-variant-id');
			var qty_container = $(this).find('.cart-details-price-quantity-container > .cart-quantity').html();
			if ( qty_container ) 
			{				
				qty_container = qty_container.replaceAll("data-ajax-cart-request-button","data-ajax-cart-request-button-new");
				qty_container = '<div class="cart-quantity cart-product-details-styling">'+qty_container+"</div>";
				
				$('.welleasy-responsive-table-row[data-variant-id="'+order_cart_variant_id+'"] .cart-quantity').remove();
				$('.welleasy-responsive-table-row[data-variant-id="'+order_cart_variant_id+'"] .order-history-addToCart').hide().after(qty_container);
				$('.welleasy-responsive-table-row[data-variant-id="'+order_cart_variant_id+'"]').addClass('not-in-cart');
			}

			var input = $('.welleasy-responsive-table-row[data-variant-id="'+order_cart_variant_id+'"] .not-in-cart .cart-quantity input');
			if(input.val() == input.data('max')){
				$(this).parents('.cart-quantity').find('.cart-quantity-value-change[data-type="plus"]').addClass('disabled');
			}
		});
		$(".order-history-addToCart").removeClass('loading');
		setUpCartEventsWellEasy();
	}
	function wishlistUpdateGridSection() {
		$('.main-wishlist .wishlist-container').removeClass('not-in-cart');
		$('.main-wishlist .wishlist-container:not(.not-in-cart) .wishlist-addToCart').show();
		$('.main-wishlist .wishlist-container .cart-quantity').hide();
		$('.cart-drawer-items-container .we_cart_item').each(function(){
			var wishlist_cart_product_handle = $(this).attr('data-product-handle');
			var qty_container = $(this).find('.cart-details-price-quantity-container > .cart-quantity').html();
			if( qty_container )
			{
				qty_container = qty_container.replaceAll("data-ajax-cart-request-button","data-ajax-cart-request-button-new");
				qty_container = '<div class="wishlist-quantity-container cart-quantity cart-product-details-styling">'+qty_container+"</div>";
				$('.main-wishlist .wishlist-container a[data-wishlist-anchor][href="/products/'+wishlist_cart_product_handle+'"] .cart-quantity').remove();
				$('.main-wishlist .wishlist-container a[data-wishlist-anchor][href="/products/'+wishlist_cart_product_handle+'"] .wishlist-addToCart').hide().after(qty_container);
				$('.main-wishlist .wishlist-container a[data-wishlist-anchor][href="/products/'+wishlist_cart_product_handle+'"]').parents(".wishlist-container").addClass('not-in-cart');
			}

			var input = $('.main-wishlist .wishlist-container.not-in-cart a[data-wishlist-anchor][href="/products/'+wishlist_cart_product_handle+'"] .cart-quantity input');
			if(input.val() == input.data('max')){
				$(this).parents('.cart-quantity').find('.cart-quantity-value-change[data-type="plus"]').addClass('disabled');
			}
		});
		$(".main-wishlist .wishlist-price-container .add-to-cart-new").removeClass('loading');
		setUpCartEventsWellEasy();
	}

	setUpCartEventsWellEasy();

    function SetPDPOneTimeQty( productItem, qty )
    {
        var onetimeATCContainer = productItem.querySelector( ".onetime-purchase-controls .product-buy-button-col" );
        var onetimeQtyContainer = productItem.querySelector( ".onetime-purchase-controls .product-quantity-col" );
        
        if ( qty > 0 )
        {
            onetimeQtyContainer.classList.remove( "hidden" );
            onetimeATCContainer.classList.add( "hidden" );

            onetimeQtyContainer.querySelector( "input.quantity__input" ).value = qty;
        }
        else
        {
            onetimeQtyContainer.classList.add( "hidden" );
            onetimeATCContainer.classList.remove( "hidden" );
        }

        // something randomly dsiables the product form...
        var form = onetimeATCContainer.querySelector( "form" );
        form.classList.remove( "disabled" );
        form.removeAttribute( "disabled" );
    }
	function SetPDPAutoshipQty( productItem, qty )
	{
		var autoshipATCContainer = productItem.querySelector( ".autoship-purchase-controls button.autoship-add-to-cart" );
		var autoshipQtyContainer = productItem.querySelector( ".autoship-purchase-controls .pdp-autoship-qty" );

		if ( qty > 0 )
		{
			if( autoshipATCContainer && autoshipQtyContainer )
			{
				autoshipQtyContainer.classList.remove( "hidden" );
				autoshipATCContainer.classList.add( "hidden" );
				autoshipQtyContainer.querySelector( ".pdp-autoship-qty-count" ).innerText = AutoshipQtyString( qty );
			}
		}
		else
		{
			var hasAutoship = false;
			var vidElement  = productItem.querySelector( "form[action='/cart/add'] input[name='id']" );

			if ( vidElement )
			{
				var vid = vidElement.value;
				hasAutoship = !!document.querySelector(
					".cart-drawer__content .cart-drawer-items-container .we_cart_item[data-variant-id='" + vid + "'][data-selling-plan-id]"
				);
			}

			if( autoshipATCContainer && autoshipQtyContainer )
			{
				if ( hasAutoship )
				{
					autoshipQtyContainer.classList.remove( "hidden" );
					autoshipATCContainer.classList.add( "hidden" );
				}
				else
				{
					autoshipQtyContainer.classList.add( "hidden" );
					autoshipATCContainer.classList.remove( "hidden" );
				}
			}
		}
	}


    function SetPDPButtonStates( )
    {
        console.log( "setting pdp button states" );
        var productItems = document.querySelectorAll( "product-info" );
        if ( productItems.length > 0 )
        {
            productItems.forEach( function( productItem )
            {
                SetPDPOneTimeQty( productItem, 0 );
                SetPDPAutoshipQty( productItem, 0 );

                var vidElement = productItem.querySelector( "form[action='/cart/add'] input[name='id']" );
                if ( vidElement )
                {
                    var vid         = vidElement.value;
                    var cartItems   = document.querySelectorAll( `.cart-drawer-items-container .we_cart_item[data-variant-id='${vid}']` );
                    var onetimeeQty = 0;
                    var autoshipQty = 0;

                    if ( window._autoshipData )
                    {
                        var pid    = productItem.getAttribute( "data-product-id" );
                        const info = getRechargeLineInfo( window._autoshipData, pid, vid );
                        if ( ( info ) && ( info.sid ) && ( info.qty > 0 ) )
                        {
                            autoshipQty = info.qty;
                        }
                    }

                    cartItems.forEach( function( cartItem )
                    {
                        var qty = Number( cartItem.querySelector( "input.cart-quantity-value" ).value );
                        if ( cartItem.getAttribute( "data-selling-plan-id" ) )
                        {
                            if ( !( window._autoshipData ) )
                            {
                                // only include subscriptions in the cart if user has no autoship order
                                autoshipQty += qty;
                            }
                        }
                        else
                        {
                            onetimeeQty += qty;
                        }
                    } );

                    SetPDPOneTimeQty( productItem, onetimeeQty );
                    SetPDPAutoshipQty( productItem, autoshipQty );

                    if ( !vidElement._variantChangeHandlerInstalled )
                    {
                        vidElement._variantChangeHandlerInstalled = true;
                        vidElement.addEventListener( "change", SetPDPButtonStates );
                    }
                }
            } );
        }
    }
    
	function updateGridSection()
    {
        var gridItems = document.querySelectorAll( `.product-grid__product-card:not( .product-grid__product-card--skeleton )` );
        gridItems.forEach( function( gridItem )
        {
            var vid           = gridItem.getAttribute( "data-variant-id" );
            var pid           = gridItem.getAttribute( "data-product-id" );
            var onetimeATC    = gridItem.querySelector( ".product-card__buy-button" );
            var onetimeQty    = gridItem.querySelector( "quantity-input" );
			var gridPlusBtn	  = gridItem.querySelector( ".quantity__button[name='plus']" );
            var autoshipATC   = gridItem.querySelector( ".autoship-add-to-cart" );
            var autoshipQty   = gridItem.querySelector( ".pdp-autoship-qty" );
            var cartItems     = document.querySelectorAll( `.cart-drawer-items-container .we_cart_item[data-variant-id='${vid}']` );
            var onetimeeCount = 0;
            var autoshipCount = 0;

            onetimeATC.removeAttribute( "style" ); // something sets a display: none; on this button soemtimes - to do : find out what !
            onetimeATC.classList.remove( "hidden" );
            onetimeQty.classList.add( "hidden" );
            autoshipATC.classList.remove( "hidden" );
            autoshipQty.classList.add( "hidden" );

            if ( window._autoshipData )
            {
                const info = getRechargeLineInfo( window._autoshipData, pid, vid );
                if ( ( info ) && ( info.sid ) && ( info.qty > 0 ) )
                {
                    autoshipCount = info.qty;

                    setupCollectionAutoshipQuantity( autoshipQty, info.sid, autoshipATC );
                }
            }


            cartItems.forEach( function( cartItem )
            {
                var qty = Number( cartItem.querySelector( "input.cart-quantity-value" ).value );
				var cartPlusBtn = cartItem.querySelector( ".cart-quantity-value-change[data-type='plus'" );
				var cartQtyInput = cartItem.querySelector( ".cart-quantity-value" );
				if( cartQtyInput.dataset.variantId == vid && cartPlusBtn.classList.contains( "cart-quantity-value-unchangeable" ) )
				{
					gridPlusBtn.setAttribute( "disabled", "" );
				}
				else
				{
					gridPlusBtn.removeAttribute( "disabled" );
				}
                if ( cartItem.getAttribute( "data-selling-plan-id" ) )
                {
                    if ( !window._autoshipData || window._autoshipData.charges )
                    {
                        // only include subscriptions in the cart if user has no autoship order
                        autoshipCount += qty;
                    }
                }
                else
                {
                    onetimeeCount += qty;
                }
            } );

            if ( autoshipCount > 0 )
            {
                autoshipATC.classList.add( "hidden" );
                autoshipQty.classList.remove( "hidden" );
                autoshipQty.querySelector( ".pdp-autoship-qty-count" ).innerText = AutoshipQtyString( autoshipCount );
            }
            if ( onetimeeCount > 0 )
            {
                onetimeATC.classList.add( "hidden" );
                onetimeQty.classList.remove( "hidden" );

                var inputElement = onetimeQty.querySelector( ".quantity__input" );
                inputElement.value = onetimeeCount;
                inputElement.setAttribute( "data-cart-quantity", onetimeeCount );
            }
        } );

        SetPDPButtonStates( );
        
        // anybody know what this is for ?
		if(typeof(RunWishlist) == 'function' && typeof(wishlistIconAdd) == 'function')
        {
			wishlistIconAdd();
		}
	}

	function wishlistButtonEvent(){
		if ($(".snize-product").length > 0){
			setTimeout(function(){
				if ($(".snize-product .icon_wrapper").length == 0){
					setTimeout(function(){
						wishlistIconAdd();
					}, 200);
				} else {
					wishlistIconAdd();
				}
			}, 200);
			function wishlistIconAdd() {
				$(".snize-product").each(function(){
					var product_id = $(this).attr('id');
					if (product_id) 
					{
						product_id = product_id.replace("snize-product-","");
					}
					if ($(this).find(".snize-thumbnail .button--wishlist").length == 0){

                        // mw emergency patch to fix live issue - wishlist dataset needs product handle
                        var link   = $(this).find( "a" )[ 0 ];
												if (link) {
													var parts  = link.getAttribute( "href" ).split( "/products/");
													var handle = parts[ 1 ];
												}
						$(this).find(".snize-thumbnail").append('<div class="icon_wrapper"><button type="button" aria-label="Add to wishlist" data-item-wished class="button--wishlist lightning-wishlist-control" button-wishlist data-product-handle="' + handle + '" data-product="'+product_id+'"><svg class="icon icon-heart" viewBox="0 0 290 256" xmlns="http://www.w3.org/2000/svg"><path d="M258.844192 127.790368L145 241.63456 31.1558082 127.790368c-26.9461761-26.946176-26.9461761-70.6345598 0-97.5807359 26.9461762-26.94617613 70.6345598-26.94617613 97.5807358 0L145 46.4730881l16.263456-16.263456c26.946176-26.94617613 70.63456-26.94617613 97.580736 0 26.946176 26.9461761 26.946176 70.6345599 0 97.5807359z" stroke="#000" stroke-width="20" fill="red" fill-rule="evenodd"/></svg></button></div>');
					}
					$(".snize-product .button--wishlist").off().click(function(e){
						e.preventDefault();
						if(!window.welleasyCustomerId){
							window.location.href = "/pages/sign-in";
						}else {
							$(this).addClass('is-adding');
							HandleWishlistClick(e.currentTarget)
						}
					});
				});
				RunWishlist();
			}
		}
	}

	/* ===================== Order History  ===================== */
	var orderHistoryTotalSaving = 0;
    function loadOrderViaAjax(nextLink){
		$(".welleasy-member-savings-wrapper .orderSavingsText").removeClass('hide');
        var params = {
            type: 'GET',
            url: nextLink,
            success: function (orderHistoryhtml) {
                orderHistoryhtml = new DOMParser().parseFromString(orderHistoryhtml, 'text/html');
                var orderHistoryData = orderHistoryhtml.querySelector('.cart-order-history-container');
                var newSaving = parseInt(orderHistoryhtml.querySelector('.welleasy-member-savings-wrapper #savings-member-text').getAttribute('data-member-saving'));

                $(".welleasy-member-savings-wrapper #savings-member-text").html((orderHistoryTotalSaving+newSaving)/100)
                // console.log(orderHistoryTotalSaving+'--'+newSaving);
                orderHistoryTotalSaving = newSaving + orderHistoryTotalSaving;

                if(orderHistoryData){
                    $(".cart-order-history-container").append(orderHistoryData.innerHTML);
                    if(orderHistoryhtml.querySelector('.welleasy-order-history-wrapper + .pagination .next')){
                        var getNextPageLink = orderHistoryhtml.querySelector('.welleasy-order-history-wrapper + .pagination .next a').getAttribute("href");
                        loadOrderViaAjax(getNextPageLink);
                    } else {
						$(".welleasy-member-savings-wrapper .orderSavingsText").addClass('hide');
						$(".welleasy-member-savings-wrapper #savings-member-text").html("£"+(orderHistoryTotalSaving)/100).parents('.saved_text').removeClass('hide');
						// console.log("===== Request Complete ======");
                    }
                }
            },
            error: function (XMLHttpRequest, textStatus) {

            }
        };
        // console.log(params);
        jQuery.ajax(params);

    }
    if($(".welleasy-order-history-wrapper + .pagination .next").length > 0){
        orderHistoryTotalSaving = parseInt($(".welleasy-member-savings-wrapper #savings-member-text").data('member-saving'));
        loadOrderViaAjax($(".welleasy-order-history-wrapper + .pagination .next a").attr('href'));
    }

	function changeCartWellEasy(action, e)
    {
		//wtf?
		action = action.substring(action.indexOf('change') + 6);
		var input = e.target.closest( ".cart-quantity" )
		var new_params = new URLSearchParams(action);
		var qty_item = new_params.get('quantity');
		var line_item = new_params.get('line');
		var selling_plan = new_params.get('selling_plan');

		var dataString = 'quantity=' + qty_item + '&line=' + line_item;

		if( action.includes( "selling_plan" ) && selling_plan )
		{
			dataString += '&selling_plan=' + selling_plan;
		}
		else if( action.includes( "selling_plan" ) )
		{
			dataString += '&selling_plan=';
		}
		
		dataString += '&sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template';

		var params = {
			type: 'POST',
			url: '/cart/change.js',
			data: dataString,
			dataType: 'json',
			success: function (cart)
        {
				updateCartDrawer(cart);
				$('#CartCount, .cart_item_count > span').text(cart.item_count);
				chagine_event_welleasy = false;
				setUpCartEventsWellEasy();
				updateGridSection();
				orderUpdateGridSection();
				wishlistUpdateGridSection();
				toggleMembershipDetails();
				updateSellingPlanPrice();
				//HandleFormV2Buttons( cart );
			},
			error: function (XMLHttpRequest, textStatus)
            {
				input.querySelector( ".qty-spinner" ).classList.add( "hidden" );
				input.querySelectorAll( ".cart-quantity-value-change" ).forEach( el => el.classList.remove( "disabled" ) );
				input.querySelector( ".cart-quantity-value" ).disabled = false;
			}
		};

        
		// console.log(params);
		jQuery.ajax(params);
	}

	
	function addCartWellEasy(data){

		var params = {
			type: 'POST',
			url: '/cart/add.js',
			data: data+'&sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template',
			dataType: 'json',
			success: function (cart) {
				KlaviyoTrack( "Added to Cart", cart );
				updateCartDrawer(cart);
				var cart_count = $('#CartCount').text();
				cart_count = parseInt(cart_count);
				$('#CartCount').text(cart_count)
				setUpCartEventsWellEasy();
				updateGridSection();
				orderUpdateGridSection();
				wishlistUpdateGridSection();
				// console.log(new Date());
			},
			error: function (XMLHttpRequest, textStatus) {

			}
		};
		// console.log(params);
		jQuery.ajax(params);
	}

	updateGridSection();
	orderUpdateGridSection();
	wishlistUpdateGridSection();


	$(document).mouseup(function(e) {
		var container = $("#cart-drawer-wellEasy .cart-drawer__content");
		var content = $(".snize-product .cart-quantity");

		    // if the target of the click isn't the container nor a descendant of the container
		    if (!container.is(e.target) && container.has(e.target).length === 0) {
		    	container.parents('body').removeClass('cart-drawer--show');
		    }

		    if (!content.is(e.target) && content.has(e.target).length === 0) {
		    	e.preventDefault();
		    }

		});

	if (!$(".welleasy-new-cart-template-section").length){
		$('.cart-quantity-value-change[data-type="minus"]').off().click(function(){
			var variant_id = $(this).parents('.cart-quantity').find('input').data('variant-id');
			$('#cart-drawer-wellEasy .cart-drawer-items-container .we_cart_item[data-variant-id="' + variant_id + '"] a[data-type="minus"]').trigger('click');
		});
		$('.cart-quantity-value-change[data-type="plus"]').off().click(function(e){
			var variant_id = $(this).parents('.cart-quantity').find('input').data('variant-id');
			//// console.log($(this).parents('.cart-quantity').find('input').data('variant-id'));
			if (checkProductInventoryWellEasy(e.currentTarget)){
				//// console.log(('#cart-drawer-wellEasy .cart-drawer-items-container .we_cart_item[data-variant-id="' + variant_id + '"]'));
				$('#cart-drawer-wellEasy .cart-drawer-items-container .we_cart_item[data-variant-id="' + variant_id+'"] a[data-type="plus"]').trigger('click');
			}

		});
		$('.quantity__remove[data-type="remove"]').off().click(function(){
			var variant_id = $(this).parents('.cart-quantity').find('input').data('variant-id');
			$('#cart-drawer-wellEasy .cart-drawer-items-container .we_cart_item[data-variant-id="' + variant_id + '"] a[data-type="remove"]').trigger('click');
		});
	}

	function checkProductInventoryWellEasy(element){
		var parent = SearchParentsFor(element, "cart-quantity");
		var input = parent.querySelector("input");
		var item_inventory = input.getAttribute("data-max") || 0;
		var collectionQtySel = document.querySelector( `.product-grid__product-card quantity-input[data-variant-id="${input.dataset.variantId}"]` );

		if ($(element).parents('.snize-overhidden').find('.snize-title').length > 0){
			var product_title = $(element).parents('.snize-overhidden').find('.snize-title').html();
		}else{
			var product_title = $(element).parents('.products-in-cart').find('.cart-description').html();
		}
		var increasedQty = Number(input.value);

        if (element.dataset.type == "minus" && element.parentElement.querySelector( ".cart-quantity-value-change[data-type='plus']" ).hasAttribute( "disabled" ) ) {
            element.parentElement.querySelector( ".cart-quantity-value-change[data-type='plus']" ).removeAttribute( "disabled" );
			if( collectionQtySel.querySelector( ".quantity__button[name='plus']" ).hasAttribute( "disabled" ) )
			{
			    collectionQtySel.querySelector( ".quantity__button[name='plus']" ).removeAttribute( "disabled" );
			}
		}

		if (Number(increasedQty) > Number(item_inventory) && Number(item_inventory) != 0) {
			//theme.showQuickPopup('Sorry we have no more stock of ' + product_title, $(element))
			element.classList.add('disabled');
			input.value = input.defaultValue;
			if ($(window).width() < 525 && $('body').hasClass('cart-drawer--show')){
				$(".simple-popup").addClass('drawer-popup ' + element.dataset.type);
			}

			if ( collectionQtySel )
			{
				collectionQtySel.input.value = input.value;
                collectionQtySel.querySelector( `.quantity__button[name="${element.dataset.type}"]` ).setAttribute( "disabled", "" );
			}

			return false;
		}
		else if (increasedQty == item_inventory && item_inventory != 0 && element.dataset.type == "plus" ) {
			element.classList.add('disabled');
			if ($(window).width() < 525 && $('body').hasClass('cart-drawer--show')){
				$(".simple-popup").addClass('drawer-popup ' + element.dataset.type);
			}

			if ( collectionQtySel )
			{
				collectionQtySel.input.value = input.value;
                collectionQtySel.querySelector( `.quantity__button[name="${element.dataset.type}"]` ).setAttribute( "disabled", "" );
			}
		}
		else
		{
			var collectionQtySel = document.querySelector( `.collection-template-v2__product-grid quantity-input[data-variant-id="${input.dataset.variantId}"]` );
			if ( collectionQtySel && collectionQtySel.querySelector( `.quantity__button[name="plus"]` ).hasAttribute( "disabled" ) )
			{
				collectionQtySel.querySelector( `.quantity__button[name="plus"]` ).removeAttribute( "disabled" );
			}
		}
		return true;
	}


	/*if (($("body.template-product").length > 0) && ($(".product-form.ajax-product-form").length > 0)){
		var product_id = $(".product-form.ajax-product-form select[name=id]").data('productid');
		var cart_drawer_item = $(".cart-drawer-items-container .products-in-cart[data-product-id='" + product_id+"']");
		if (cart_drawer_item.length > 0){
			$(".product-layout-grid__detail .cart-quantity.cart-product-details-styling").remove();
			$(".product-form.ajax-product-form").before("<div class='cart-quantity cart-product-details-styling'>" + $(".cart-details-price-quantity-container .cart-quantity").html()+"</div>");
			$(".product-form.ajax-product-form").hide();
			setUpCartEventsWellEasy();
		}
	}*/

	window.addEventListener('cart_item_added',function(){
		setUpCartEventsWellEasy();
	});
// }, 2000);

function updateCartDrawer(cart)
{
	if ($(".cart-drawer-items-container").length > 0){
		var top_position = $(".cart-drawer-items-container")[0].scrollTop;
	}
	$('#cart-drawer-wellEasy').html(cart.sections['cart-drawer-section']);
    setUpCartEventsWellEasy( );

	if ($(".cart-drawer-items-container").length > 0) {
		$(".cart-drawer-items-container").scrollTop(top_position);
	}

	if ($(".welleasy-new-cart-template-section .cart-products-items-container").length > 0) {
		var top_position = $(".welleasy-new-cart-template-section .cart-products-items-container")[0].scrollTop;
	}
	if ( ( $("#shopify-section-welleasy-new-cart-template").length > 0 ) && ( cart.sections['welleasy-new-cart-template'] ) )
    {
		$("#shopify-section-welleasy-new-cart-template").html(cart.sections['welleasy-new-cart-template']);
	}
	if ($(".welleasy-new-cart-template-section .cart-products-items-container").length > 0) {
		$(".welleasy-new-cart-template-section .cart-products-items-container").scrollTop(top_position);
	}
	if($(".cart_order_summary").length > 0){
		if ($(".cart_order_summary").length > 1){
			$(".cart_order_summary").each(function(){
				if($(this).find(".cart-products-items-container").length > 0){
					var order_summary_scroll_position = $(this).find(".cart-products-items-container")[0].scrollTop;
				}
				$(this).html(cart.sections['cart-products-auto-render']);
				if($(this).find(".cart-products-items-container").length > 0){
					$(this).find(".cart-products-items-container").scrollTop(order_summary_scroll_position);
				}
			});

			$(".cart_order_summary").each(function(){
				var order_summary_scroll_position = $(this).find(".cart-products-items-container")[0].scrollTop;
				$(this).html(cart.sections['cart-products-auto-render']);
				$(this).find(".cart-products-items-container").scrollTop(order_summary_scroll_position);
			});
		}else{
			var order_summary_scroll_position = $(".cart_order_summary .cart-products-items-container")[0].scrollTop;
			$(".cart_order_summary").html(cart.sections['cart-products-auto-render']);
			$(".cart_order_summary .cart-products-items-container").scrollTop(order_summary_scroll_position);
		}
	}
	$(".desktop-new-cart-wrapper .utils__item > span").html($(".cart-drawer-subtotal").html());

    if ( cart.item_count != undefined )
    {
        $('#CartCount').text( cart.item_count )
    }
    else
    {
        $.ajax( { "type" :'GET', "url": '/cart.js', "dataType": 'json', "success": function( data )
        {
            $('#CartCount').text( data.item_count )
        } } );
    }
}

if ($("#membership_form .membership-choice-next").length > 0){
	$("#membership_form .membership-choice-next").removeAttr('disabled');
}
$("#membership_form .membership-choice-next").removeAttr('disabled');
function addRemoveMembershipsCheckout(data_items, key) {
	// console.log("cart:"+key);
	if($(".membership-choice-welleasy[data-variant-id='"+data_items[key].id+"']").length > 0){
		var params = {
			type: 'POST',
			url: '/cart/change.js',
			data: 'quantity=0&line=' + (key+1),
			dataType: 'json',
			success: function (cart) {
				if((key+1) == data_items.length){
					// console.log("cart",(key+1), data_items.length);
    				setTimeout(function(){
    					$(".membership-choice-extra-info #membership_form").unbind().submit();
    				},500);
    			}else{
    				addRemoveMembershipsCheckout(data_items, key+1);
    			}
			},
			error: function (XMLHttpRequest, textStatus) {}
		};
		$.ajax(params);
	}else{
		if((key+1) == data_items.length){
			// console.log("cart",(key+1), data_items.length);
			setTimeout(function(){
				$(".membership-choice-extra-info #membership_form").unbind().submit();
			},500);
		}else{
			addRemoveMembershipsCheckout(data_items, key+1);
		}
	}
}

$(document).ready(function(){
	$.ajax({
		url: '/?sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template-section',
		dataType: 'json',
		success: function (data) {
			$("#cart-drawer-wellEasy").html(data['cart-drawer-section']);
			toggleTooltip();
			updateSellingPlanPrice();
            setUpCartEventsWellEasy( );
		}
	});

    $('.cart-free-products-container').slick({
	    dots: true,
	    infinite: true,
	    speed: 300,
	    slidesToShow: 3,
		asNavFor: '.cart-drawer_btn-container',
	    slidesToScroll: 1,
	    responsive: [
	    {
	        breakpoint: 900,
	        settings: {
	            slidesToShow: 2,
	            slidesToScroll: 1,
	            dots: true,
	            arrows: false
	        }
	    },
	    {
	        breakpoint: 650,
	        settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false,
	            arrows: true
	        }
	    }
    	]
	});
	$('.cart-drawer_btn-container').slick({
		dots: true,
	    infinite: true,
	    speed: 300,
	    slidesToShow: 3,
		asNavFor: '.cart-free-products-container',
	    slidesToScroll: 1,
		arrows: false,
	    responsive: [
	    {
	        breakpoint: 900,
	        settings: {
	            slidesToShow: 2,
	            slidesToScroll: 1,
	            dots: true,
	            arrows: false
	        }
	    },
	    {
	        breakpoint: 650,
	        settings: {
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            dots: false,
	        }
	    }
    	]
	  });

    $('.testomonial_slide').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        arrows: false
    });

		$(".create--account").submit(function(){
			addAnnualSubscription( this, true );
		});

	$(".membership-choice-save-popup a").click(function(){
		theme.showQuickPopup('Projected savings are estimated based on your savings on your first order and current member savings. We guarantee you’ll make back your membership fee in savings, or we’ll refund you the difference! See our FAQs for details.', $(this));
		if ($(window).width() < 767){
			$(".simple-popup").addClass('create-account-popup');
		}
	});

	jQuery(".membership-choice-welleasy").click(function(){
		jQuery(".membership-choice-welleasy").removeClass('active');
		jQuery(this).addClass('active');
		var product_id = $(this).data('variant-id');
		//jQuery(".membership-choice-next").attr('href','/cart/'+product_id+':1');
		jQuery(".membership-choice-extra-info form input[name='id']").val(product_id);
	});

	//============================ Move to top in this file ==================================
	
	//=====================================================================================================

	$(".membership-choice-next").click(function(){
		$("body").addClass("checkout-loading");
		setTimeout(function(){
			$(this).attr('disabled','disabled');
		},100);
	});

	$(".blog-product-form").submit(function(e){
		e.preventDefault();
		var product_id = $(this).find('input[name="id"]').val();
		if(product_id){
			addCartWellEasyArticle('id='+product_id+'&quantity=1',$(this));
		}
	});

	// $(".cart-order-history-product-card a").click(function(e){
	// 	e.preventDefault();
	// 	var product_id = $(this).parent().data('variant-id');
	// 	if(product_id){
	// 		addCartWellEasyArticle('id=' + product_id + '&quantity=1', false, $(this).find('p'));
	// 	}
	// });

	if($(".evm-related-product").length > 0){
		var rp_container_observer = new MutationObserver( function( ml, o )
		{
			rp_container_observer.takeRecords( );
			rp_container_observer.disconnect( );

			var rp_wp_related_product_observer = new MutationObserver( function( ml, o )
			{
				rp_wp_related_product_observer.takeRecords( );
				rp_wp_related_product_observer.disconnect( );
				rp_wp_related_product_observer.observe($('.evm-related-product .evm-wscontainer.wise-product-section').get(0), { "childList": true, "subtree": true });

				jQuery.get('/?sections=cart-drawer-section',function(cart){
					updateCartDrawer({sections:cart});
				});
			} );
			rp_wp_related_product_observer.observe( $('.evm-related-product .evm-wscontainer.wise-product-section').get(0), { "childList": true, "subtree" : true } );

		} );
		rp_container_observer.observe( $('.evm-related-product').get(0), { "childList": true, "subtree" : true } );
	}
	if ($('.evm-featured-collections-product').length > 0){
		var fc_container_observer = new MutationObserver( function( ml, o )
		{
			fc_container_observer.takeRecords( );
			fc_container_observer.disconnect( );

			var fc_wp_related_product_observer = new MutationObserver( function( ml, o )
			{
				fc_wp_related_product_observer.takeRecords( );
				fc_wp_related_product_observer.disconnect( );
				fc_wp_related_product_observer.observe($('.evm-featured-collections-product .evm-wscontainer.wise-product-section').get(0), { "childList": true, "subtree": true });

				jQuery.get('/?sections=cart-drawer-section',function(cart){
					updateCartDrawer({sections:cart});

				});
			} );
			fc_wp_related_product_observer.observe( $('.evm-featured-collections-product .evm-wscontainer.wise-product-section').get(0), { "childList": true, "subtree" : true } );

		} );
		fc_container_observer.observe( $('.evm-featured-collections-product').get(0), { "childList": true, "subtree" : true } );
	}

	function reorderAddToCart(available_ids, i,element) {
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: 'quantity=1&id=' + available_ids[i] + '&sections=cart-drawer-section,cart-products-auto-render',
			dataType: 'json',
			success: function (cart) {
				updateCartDrawer(cart);
				var cart_count = $('#CartCount').text();
				cart_count = parseInt(cart_count);
				$('#CartCount').text(cart_count + 1)

				if (i + 1 == available_ids.length) {
					element.html('Added to basket');
					setTimeout(function () {
						element.html('Reorder');
						element.removeClass("show-icon");
						element.parent(".welleasy-reorder-wrapper").find(".show--text").remove();
					}, 2000);
				}else{
					i++;
					reorderAddToCart(available_ids, i, element);
				}
			},
			error: function () {
				// console.log('error');
				if (i + 1 != available_ids.length) {
					i++;
					reorderAddToCart(available_ids, i, element);
				}
			}
		});
	}

	$(".welleasy-reorder-button").click(function (e) {
		e.preventDefault();
		var _this = $(this);
		_this.html('Adding to basket <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path></svg>');
		_this.addClass("show-icon");
		if ($(".welleasy-reorder-wrapper .show--text").length == 0) {
			_this.after('<p class="show--text">This may be slow</p>');
		}

		var ids = $(this).siblings('input').data('order-variant-id');
		var thisQty = 1;
    	if (typeof(ids) == "string" && ids.includes(",")){
			var available_ids = ids.split(',');
		}else{
			var available_ids = [ids];
		}

		reorderAddToCart(available_ids, 0,_this);
	    /* for (var i = 0; i < available_ids.length; i++) {
	      (function (i) {
	          var params = {
	            type: 'POST',
	            url: '/cart/add.js',
	            data: 'quantity=' + thisQty + '&id=' + available_ids[i] + '&sections=cart-drawer-section,cart-products-auto-render',
	            dataType: 'json',
	            async:false,
	            success: function (cart) {
	              // // console.log("success! - " + cart.title);
	              // console.log('---' + i + '----');
	              updateCartDrawer(cart);
	              	var cart_count = $('#CartCount').text();
					cart_count = parseInt(cart_count);
					$('#CartCount').text(cart_count+1)

	              var iteration_length = i + 1;
	              //if iteration length is equal to the total length - it means that we have
	              //reached the last item. Now we redirect to cart or may be show pop up
	              if (iteration_length == available_ids.length) {
	                //redirect to cart or
	                // document.location.href = '/cart';
	              }
	            },
	            error: function (response) {
	              // _this.after('<p class="error">' + error.responseJSON.description + '</p>');
	              // // console.log("fail");
	            }
	          };
	          $.ajax(params);
	      }(i));
	    }*/
	});

	$(".product-detail__images > .product-detail__image:not(:first-child) a").off().click(function(e){
		e.preventDefault();

		var new_href = $(this).attr('href');
		var old_href = $(".product-detail__images > .product-detail__image:first-child a").attr('href');

		$(".product-detail__images > .product-detail__image:first-child a").attr('href',new_href);
		$(this).attr('href',old_href);

		var new_img = $(this).find('.rimage-wrapper').html();
		var old_img = $(".product-detail__images > .product-detail__image:first-child a").find('.rimage-wrapper').html();

		$(".product-detail__images > .product-detail__image:first-child a .rimage-wrapper").html(new_img);
		$(this).find('.rimage-wrapper').html(old_img);
		window.dispatchEvent(new Event('resize'));
	});
	if ($(".free-gift-product-wrapper .cart-free-gift-wrapper").length > 0) {
		$(".membership-choice-welleasy--box").addClass("hidden");
	} else {
		$(".membership-choice-welleasy--box").removeClass("hidden");
	}
	$(".cw-btn").off().click(function(){
		$(window).scrollTop(0);
		$(".membership-choice-welleasy--box").removeClass("hidden");
		$('.free-gift-product-wrapper').slideUp();
		$("body").removeClass('giftCardShow');
		window.dispatchEvent(new Event('resize'));
		if($('.membership-work-slider').length > 0){
			$('.membership-work-slider').slick('refresh');
		}
		if($('.welleasy-testimonial-slider').length > 0){
			$('.welleasy-testimonial-slider').slick('refresh');
		}
	});

	/*
	** Wishlist page item search
	**/
	$(".wishlist-body #open-search-bar").keyup(function(){
		var input, filter, table, tr, td, i, txtValue;
		input = document.querySelector(".wishlist-body #open-search-bar");
		filter = input.value.toUpperCase();
		table = document.querySelector(".main-wishlist");
		tr = table.querySelectorAll(".wishlist-container");
		for (i = 0; i < tr.length; i++) {
			td = tr[i].querySelector(".wishlist-title-container");
			if (td) {
				txtValue = td.textContent || td.innerText;
				if (txtValue.toUpperCase().indexOf(filter) > -1) {
					tr[i].style.display = "";
				} else {
					tr[i].style.display = "none";
				}
			}
		}
	});
	/* ** End Wishlist page item search */
});

// setTimeout(function(){
// 	function evm_sidebar_interval() {
// 		var evmSidebarInterval;
// 		$(".evm-ws__cart-submit").off().click(function () {
// 			clearInterval(evmSidebarInterval);
// 			evmSidebarInterval = setInterval(function () {
// 				if ($(".ws-ajaxified-cart-feedback .fa-check").length > 0) {
// 					clearInterval(evmSidebarInterval);
// 					evm_sidebar_interval();
// 					setTimeout(function(){
// 						$("body.template-product").addClass("cart-drawer--show");
// 					}, 500);
// 				}
// 			}, 200);
// 		});
// 	}
// 	evm_sidebar_interval();
// },2000);


function addCartWellEasyArticle(data,show_success_element=false,text_change=false){
	var params = {
		type: 'POST',
		url: '/cart/add.js',
		data: data+'&sections=cart-drawer-section,cart-products-auto-render',
		dataType: 'json',
		success: function (cart) {
			updateCartDrawer(cart);
			var cart_count = $('#CartCount').text();
			cart_count = parseInt(cart_count);
			$('#CartCount').text(cart_count+1);

			if(show_success_element){
				var feedback_text = '<p class="ws-ajaxified-cart-feedback"><span><i class="fa fa-check"></i> Added to cart!</span> <a href="/cart">View cart</a> or <a href="/collections/all">continue shopping</a>.</p>';
				show_success_element.append(feedback_text);
				setTimeout(function () {
					$('.ws-ajaxified-cart-feedback').remove();
				}, 2000);
			}
			if(text_change){
				text_change.html('Added to basket');
				setTimeout(function () {
					text_change.html('Add to basket')
				}, 2000);
			}
		}
	};
	jQuery.ajax(params);
}


function ParseQPWellEasy( )
{
    var qpd   = { };
    var qp    = window.location.search.substr( 1 );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}

function queryParams()
{
	$( '.cart-page-grid' ).removeClass( 'hidden-until-loaded' );

	var qp = ParseQPWellEasy( );
	var cartWrapper = document.querySelector( ".cart-page-grid" );
	//// console.log(cartWrapper);
	//// console.log(qp);
	if( cartWrapper )
	{
		var registerBlock = document.querySelector( ".cart-create-account-form-wrapper" );
		var loginBlock = document.querySelector( ".cart-sign-in-form-wrapper" );
		var memberSummaryBlock = document.querySelector( ".benefits-summary-box" );
		var freeGiftBlock = document.querySelector( ".cart-free-gift-wrapper" );
		if( qp.type == "register" )
		{
			cartWrapper.classList.add( "grid-two-columns" );
			if( registerBlock )
			{
				registerBlock.classList.remove( "hidden" );
			}
		}
		else if( ( qp.type == "register-free-gift" ) )
		{
			if( freeGiftBlock )
			{
				cartWrapper.classList.add( "grid-two-columns" );
				registerBlock.classList.remove( "hidden" );
				freeGiftBlock.classList.remove( "hidden" );
			}
			else
			{
				window.history.back();
			}
		}
		else if( qp.type == "login" )
		{
			//// console.log(qp.type);
			//// console.log(loginBlock);
			cartWrapper.classList.add( "grid-two-columns" );
			if ( loginBlock )
			{
				loginBlock.classList.remove( "hidden" );
			}
			if ( memberSummaryBlock )
			{
				memberSummaryBlock.classList.add( "hidden" );
			}
		}
		else
		{
			if( registerBlock )
			{
				cartWrapper.classList.add( "grid-two-columns" );
				registerBlock.classList.remove( "hidden" );
			}
		}
	}
}

function resizeCartGrid()
{
	var qp = ParseQPWellEasy( );
	var cartWrapper = document.querySelector( ".cart-page-grid" );

	if( cartWrapper && qp.type == "register" )
	{
		if( screen.width <= 1000 && screen.width > 500 )
		{
			if( cartWrapper.classList.contains( "grid-two-columns" ) )
			{
				cartWrapper.classList.remove( "grid-two-columns" );
				cartWrapper.classList.add( "grid-two-columns" );
			}
			else if( cartWrapper.classList.contains( "grid-one-column" ) )
			{
				cartWrapper.classList.remove( "grid-one-column" );
				cartWrapper.classList.add( "grid-two-columns" );
			}
		}
		else if( screen.width <= 500 )
		{
            // // console.log("screen.width <= 500");

            if( cartWrapper.classList.contains( "grid-two-columns" ) )
            {
            	cartWrapper.classList.remove( "grid-two-columns" );
            	cartWrapper.classList.add( "grid-one-column" );
            }
            else if( cartWrapper.classList.contains( "grid-two-columns" ) )
            {
            	cartWrapper.classList.remove( "grid-two-columns" );
            	cartWrapper.classList.add( "grid-one-column" );
            }
        }
        else
        {
            // // console.log("screen.width > 1000");

            if( cartWrapper.classList.contains( "grid-two-columns" ) )
            {
            	cartWrapper.classList.remove( "grid-two-columns" );
            	cartWrapper.classList.add( "grid-two-columns" );
            }
            else if( cartWrapper.classList.contains( "grid-one-column" ) )
            {
            	cartWrapper.classList.remove( "grid-one-column" );
            	cartWrapper.classList.add( "grid-two-columns" );
            }
        }
    }
}

function resizeCartSections()
{
	var qp = ParseQPWellEasy();
	if( qp.type = "register" )
	{
		var createAccountFormBlock = $( ".create-account-form-inner" ).outerHeight();
		var benefitsSummaryBlock = $(".benefits-summary-info").outerHeight();
		if( createAccountFormBlock > benefitsSummaryBlock )
		{
			$(".benefits-summary-info").outerHeight( createAccountFormBlock );
		}
		else if( benefitsSummaryBlock > createAccountFormBlock )
		{
			$( ".create-account-form-inner" ).outerHeight( benefitsSummaryBlock );
		}
	}

	if( window.innerWidth <= 768 )
	{
		$(".benefits-summary-info").outerHeight( "unset" );
		$( ".create-account-form-inner" ).outerHeight( "unset" );
	}
}

function addFreeGift( element,show_success_element=false )
{
	// console.log(element);
	$(element).attr("disabled", true);
    var free_gift_card = SearchParentsFor( element, "cart-free-gift-product-card" );

    var params = {
		type: 'POST',
		url: '/cart/add.js',
		data: {
            quantity: 1,
            id: free_gift_card.dataset.variantId
          },
        dataType: 'json',
		success: function (cart) {
			if(free_gift_card){
				$(window).scrollTop(0);
				$('.free-gift-product-wrapper').slideUp();
				$(".membership-choice-welleasy--box").removeClass("hidden");
				$("body").removeClass('giftCardShow');
				window.dispatchEvent(new Event('resize'));
				if($('.membership-work-slider').length > 0){
					$('.membership-work-slider').slick('refresh');
				}
				if($('.welleasy-testimonial-slider').length > 0){
					$('.welleasy-testimonial-slider').slick('refresh');
				}
			}
		}
	};
	jQuery.ajax(params);
}

function SubmitRegistrationFormUsingAjax( )
{
	var selector = "form[ action='/account' ]";

	function HandleResponse( resp )
	{
        //// console.log( "rx response " + resp );
        // console.log( "rx response " );

        var parser = document.createElement( "div" );
        parser.innerHTML = resp;

        var toShow  = parser.querySelector( "main" );
        var scripts = toShow.querySelectorAll( "script" );
        var addList = [ ];

        for ( var i = 0; i < scripts.length; i++ )
        {
        	var parent = scripts[ i ].parentNode;
        	parent.removeChild( scripts[ i ] );

        	addList.push( { "parent" : parent, "script" : scripts[ i ] } );
        }

        var where = document.querySelector( ".cart-create-account-form-wrapper" );
        while ( where.firstChild )
        {
        	where.removeChild( where.firstChild );
        }

		
        where.appendChild( toShow );
		
        for ( var i = 0; i < addList.length; i++ )
        {
        	var entry = addList[ i ];
        	var src   = entry.script.getAttribute( "src" );
        	if ( src )
        	{
        		var add = document.createElement( "script" );
        		add.setAttribute( "src", src );
        		entry.parent.appendChild( add );
        	}
        	else
        	{
        		var add = document.createElement( "script" );
        		add.innerText = entry.script.innerText;
        		entry.parent.appendChild( add );
        	}
        }
    }

    $.ajax(
    {
    	"type"    : "POST",
    	"url"     : $( selector ).attr( "action" ),
    	"data"    : $( selector ).serialize(),
    	"success" : HandleResponse
    } );
}

function addAnnualSubscription( element, createAccountButton )
{
  	var annual_subscription;
  	if( createAccountButton )
    {
		annual_subscription 	= document.querySelector( ".cart-products-bottom-section" );
    }
  	else
    {
        var info_container      = SearchParentsFor( element, "cart-products__content-container" );
        annual_subscription 	= info_container.querySelector( ".cart-products-bottom-section" );
    }

    function PostDone( )
    {
		//$("#create_customer").unbind().submit();
        //window.location.href="/checkout";

      	if( createAccountButton )
        {
			verifyPassword( element );
        }
    }

    element.classList.add( "disabled" );
    element.style = "pointer-events: none;";


    var post =
    {
        quantity: 1,
        id: annual_subscription.dataset.variantId
    };

    if( annual_subscription.dataset.sellingPlanId )
    {
        post[ "selling_plan" ] = annual_subscription.dataset.sellingPlanId;
    }

    var items = [ post ];

    jQuery.post('/cart/add.js',
    {
        "items": items
    }, PostDone );
}

// mostly copied from addAnnualSubscription, but that routine seems to be called in 2 or 3 different ways
// this one is just for the basic simple sign up/add membership flow
const SUBMIT_FORM_USING_AJAX = false; // doesn't work properly (yet)
function SetupRegistrationHandling( )
{
	var selector       = "form[ action='/account' ] button[type='submit']";
	var registerButton = document.querySelector( selector );
	if ( registerButton )
	{
        // remove legacy click handler and register a listener so the default form post can be blocked if membership needs to be added
        registerButton.removeAttribute( "onclick" );

        var annual_subscription = document.querySelector( ".cart-products-bottom-section" );
        // console.log(annual_subscription);
        // console.log(annual_subscription.dataset.variantId);
        var post                = { "quantity": 1, "id": annual_subscription.dataset.variantId };

        function MemberShipAdded( )
        {
			
			registerButton.classList.remove( "disabled" );
			registerButton.removeAttribute( "style" );
			
        	if ( SUBMIT_FORM_USING_AJAX )
        	{
        		SubmitRegistrationFormUsingAjax( );
        	}
        	else
        	{
        		registerButton.removeEventListener( "click", RegisterButtonEventListener );
	                $( registerButton ).click( );   // the form submission will redirect on to the checkout when done
	            }
	        }

	        function RegisterButtonEventListener( e )
	        {
	            e.preventDefault( ); // do not submit the form yet

            // remember that the flow is sign up, for in case the registration fails
            // this is because the checkout will bounce users back to the log in form, not the registration one
	            var exp = new Date( new Date( ).getTime( ) + ( 2 * 60 * 1000 ) ); // cookie expires in two minutes
	            document.cookie = "_we_checkout_flow=register;path=/;expires=" + exp.toUTCString( );

	            var check = document.querySelector( ".cart-drawer-items-container .we_cart_item[data-variant-id='" + post.id + "']" );
	            if ( check )
	            {
                // membership product is already in the basket, can just submit the form
                // console.log( "membership product already in basket" );
                MemberShipAdded( );
            }
            else
            {
                // add membership product and selling plan ID
                if ( annual_subscription.dataset.sellingPlanId )
                {
                	post[ "selling_plan" ] = annual_subscription.dataset.sellingPlanId;
                }


                registerButton.classList.add( "disabled" );
                registerButton.style = "pointer-events: none;";
                jQuery.post( '/cart/add.js',
                {
					"items" : [ post ]
					
                }, MemberShipAdded );
            }
        }

        // console.log( "set up for adding membership" );
        registerButton.addEventListener( "click", RegisterButtonEventListener );
    }
    else
    {
    	var observer = new MutationObserver( function( ml, o )
    	{
    		var registerButton = document.querySelector( selector );
    		if ( registerButton )
    		{
    			observer.takeRecords( );
    			observer.disconnect( );
    			SetupRegistrationHandling( );
    		}
    	} );
    	observer.observe( document, { "childList": true, "subtree" : true } );
    }
}

function expandOrderHistory( element )
{
	var row = SearchParentsFor( element, "cart-order-body-wrapper" );

	var productBox = row.querySelector( ".cart-order-products-row" );
	var productCard = productBox.querySelector( ".cart-order-history-product-card-wrapper" );

	if( productBox.classList.contains( "order-history-expanded" ) )
	{
		productBox.classList.remove( "order-history-expanded" );
		// console.log("productCard offsetHeight = " + productCard.offsetHeight );
		// console.log("productBox height = " + productBox.style.height );
		productBox.style.height = productCard.offsetHeight + "px";
		element.innerHTML = "Expand";
	}
	else
	{
		productBox.classList.add( "order-history-expanded" );
		productBox.style.height = "auto";
		element.innerHTML = "Close";
	}
}

function expandOrderHistory2( element )
{
	var x = document.querySelector(".table-no-show");
	if (x.style.display === "none"){
		x.style.display = "block";
	} else {
		x.style.display = "none";
	}
}

function resizeOrderHistoryRows()
{
	var orderHistoryRow = document.querySelectorAll( ".cart-order-history-order-container" );
	for( var i = 0; i < orderHistoryRow.length; i++ )
	{
		var productBox = orderHistoryRow[ i ].querySelector( ".cart-order-products-row" );
		var productCard = productBox.querySelector( ".cart-order-history-product-card-wrapper" );

		productBox.style.height = productCard.offsetHeight + "px";
	}
}

window.addEventListener( "DOMContentLoaded", function( e )
{
	SetupRegistrationHandling( );

	queryParams();
	resizeCartGrid();
	resizeOrderHistoryRows();
});

window.addEventListener( "resize", function( e )
{
	resizeCartGrid();
	resizeCartSections();
	resizeOrderHistoryRows();
} );

function GetPageUsingAjax( url, cb )
{
    var xhr = new XMLHttpRequest( );

    xhr.onreadystatechange = function( )
    {
        if ( xhr.readyState == 4 )
        {
            cb( xhr, xhr.responseText );
        }
    };

    xhr.open( "GET", url, true );
    xhr.send( );
}

function KlaviyoTrack( event, cartItem )
{
	if( event == "Added to Cart" )
	{
		var item = 
		{
			"name"			: cartItem.name,
			"productID"		: cartItem.id,			
			"imageURL"		: cartItem.image,			
			"URL"			: cartItem.url,
			"brand"			: cartItem.brand,
			"price"			: cartItem.price,
			"compareAtPrice": cartItem.compareAtPrice
		}
		_learnq.push([ 'track', 'Added to Cart', item ]);
	}
}

function toggleTooltip() {
	const svgTooltip = document.querySelector('.membership-expired-question-tooltip');
	const tooltipQuestionMark = document.getElementById('tooltip-question-mark');
	if (!svgTooltip || !tooltipQuestionMark) return;

	svgTooltip.style.cursor = 'pointer';

	// Desktop hover
	svgTooltip.addEventListener('mouseenter', function () {
		tooltipQuestionMark.style.position = 'absolute';
		tooltipQuestionMark.style.display = 'flex';
	});
	svgTooltip.addEventListener('mouseleave', function () {
		tooltipQuestionMark.style.display = 'none';
	});
	tooltipQuestionMark.addEventListener('mouseleave', function () {
		tooltipQuestionMark.style.display = 'none';
	});

	// Mobile tap/click
	svgTooltip.addEventListener('touchstart', function (e) {
		e.preventDefault();
		tooltipQuestionMark.style.position = 'absolute';
		tooltipQuestionMark.style.top = '30px';
		tooltipQuestionMark.style.display = 'flex';
	}, { passive: false });

	document.addEventListener('touchstart', function (e) {
		if (!svgTooltip.contains(e.target) && !tooltipQuestionMark.contains(e.target)) {
			tooltipQuestionMark.style.display = 'none';
		}
	});
}


document.addEventListener('change', function(event) {
		if (event.target.matches('[data-ajax-cart-section-scroll] .autoship-switch input[type="checkbox"]')) {
				updateSellingPlanPrice();
		}
});

function updateSellingPlanPrice() {
	let totalSellingPlanPrice = 0;
	document.querySelectorAll('[data-ajax-cart-section-scroll] .we_cart_item').forEach(function(item) {
			if (item.dataset.sellingPlanId) {
					let itemPrice = parseFloat(item.dataset.cartItemPrice);
					let itemQuantity = parseInt(item.dataset.cartItemQuantity);
					totalSellingPlanPrice += itemPrice * itemQuantity;
			}
	});

	const autoshipLine = document.querySelector('.cart-drawer-autoship-line');
	if (autoshipLine) {
		if (totalSellingPlanPrice > 0) {
			autoshipLine.style.display = 'flex';
			autoshipLine.querySelector('.cart-drawer-autoship-total').textContent = Shopify.formatMoney(totalSellingPlanPrice);
		} else {
			autoshipLine.style.display = 'none';
		}
	}
}
updateSellingPlanPrice();

window.addEventListener( "DOMContentLoaded", function ()
{
	toggleMembershipDetails();
	toggleTooltip();

    updateGridSection( );
    setUpCartEventsWellEasy( );
    return;

    // used to detect what is changing the sidecart during startup
    console.log( "**********************************************************************************" );
    var element = document.querySelector( ".product-buy-button-col-autoship .produyct-form__buttons .pdp-autoship-qty" );
    console.log( element );

    var observer = new MutationObserver( function( ml, o )
    {
        var check = document.querySelector( ".product-buy-button-col-autoship .produyct-form__buttons .pdp-autoship-qty" );
        if ( !check )
        {
            console.log( "changed !" );
        }
    } );
    observer.observe( document.body, { "childList": true, "subtree" : true } );

});

// Initial calculation on page load


/* ===================== Wishlist / Grid Add-to-Cart (Lightning format) ===================== */

if (!window.__weWishlistATCBound)
{
    window.__weWishlistATCBound = true;

    $(document)
    .off('click.wlAnchorGuard')
    .on('click.wlAnchorGuard', 'a[data-wishlist-anchor]', WishlistAnchorGuardHandler);

    $(document)
    .off('submit.wlCardForm')
    .on('submit.wlCardForm', '.product-card form[action="/cart/add"]', WishlistBlockCardFormSubmit);

    $(document)
    .off('click.weATC')
    .on('click.weATC', '.add-to-cart-new, .wishlist-addToCart', WishlistAtcDelegatedHandler);

    $(window).on('load', function() 
	{
        setTimeout(function() 
		{
            wishlistUpdateGridSection();
        }, 500);
    });

    $(document).ajaxComplete(function() 
	{
        wishlistUpdateGridSection();
    });
}

function WishlistAnchorGuardHandler(e)
{
    if ($(e.target).closest('.add-to-cart-new, .wishlist-addToCart, .cart-quantity, .cart-quantity-value-change, .quantity__button, .quantity__input').length)
    {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
    }
}

function WishlistBlockCardFormSubmit(e)
{
    e.preventDefault();
    e.stopPropagation();
    return false;
}

function WishlistAtcDelegatedHandler(e)
{
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var $btn = $(this);
    $btn.addClass('loading');

    var product_id = WishlistResolveProductIdFromButton($btn);
    var variant_id = WishlistResolveVariantIdFromProductId(product_id);

    if (variant_id && Number(variant_id) > 0)
    {
        WishlistAddVariantToCart(String(variant_id), $btn);
        return;
    }

    var handle = WishlistResolveHandleFromButton($btn);
    WishlistFetchFirstVariant(handle, function(vid)
    {
        if (vid)
        {
            WishlistAddVariantToCart(String(vid), $btn);
        }
        else
        {
            WishlistRemoveLoadingClassDelayed($btn);
        }
    });
}

function WishlistResolveProductIdFromButton($btn)
{
    var product_id = null;

    var $wl = $btn.closest('.wishlist-container');
    if ($wl.length)
    {
        var $ctrl = $wl.find('.lightning-wishlist-control').first();
        if ($ctrl.length)
        {
            product_id = $ctrl.attr('data-product') || null;
        }
    }

    if (!product_id)
    {
        var $snize = $btn.closest('li.snize-product, .we-product-card-wrapper');
        if ($snize.length)
        {
            var idAttr = $snize.attr('id') || '';
            if (idAttr.indexOf('snize-product-') === 0)
            {
                product_id = idAttr.replace('snize-product-','');
            }
        }
    }

    if (!product_id)
    {
        var $wrap = $btn.closest('[id^="snize-product-"]');
        if ($wrap.length)
        {
            product_id = $wrap.attr('id').replace('snize-product-','');
        }
    }

    return product_id;
}

function WishlistResolveVariantIdFromProductId(product_id)
{
    var variant_id = -1;

    try
    {
        if (window.BOLD && window.BOLD.common && window.BOLD.common.Shopify && window.BOLD.common.Shopify.variants)
        {
            variant_id = WishlistGetVariantFromProductID(window.BOLD.common.Shopify.variants, product_id);
        }
    }
    catch (_)
    {
    }

    return variant_id;
}

function WishlistGetVariantFromProductID(obj, pid)
{
    var returnKey = -1;

    $.each(obj, function(key, info)
    {
        if (String(info.product_id) === String(pid))
        {
            returnKey = key;
            return false;
        }
    });

    return returnKey;
}

function WishlistResolveHandleFromButton($btn)
{
    var href = null;

    var $wl = $btn.closest('.wishlist-container');
    if ($wl.length)
    {
        var a = $wl.find('[data-wishlist-anchor]').first();
        if (a.length)
        {
            href = a.attr('href');
        }
    }

    if (!href)
    {
        var $link = $btn.closest('li.snize-product').find('a.snize-view-link').first();
        if ($link.length)
        {
            href = $link.attr('href');
        }
    }

    if (!href)
    {
        var $pc = $btn.closest('.product-card').find('a[href*="/products/"]').first();
        if ($pc.length)
        {
            href = $pc.attr('href');
        }
    }

    if (!href)
    {
        return null;
    }

    var parts = href.split('/products/');
    var tail  = parts[1] ? parts[1] : null;

    if (!tail)
    {
        return null;
    }

    tail = tail.replace(/^\//,'');
    tail = tail.split('?')[0];

    return tail;
}

function WishlistFetchFirstVariant(handle, cb)
{
    if (!handle)
    {
        cb(null);
        return;
    }

    var base = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
    {
        base = window.Shopify.routes.root;
    }

    $.getJSON(base + 'products/' + handle + '.json')
    .done(function(result)
    {
        var vid = null;

        if (result && result.product && result.product.variants && result.product.variants.length > 0)
        {
            for (var i = 0; i < result.product.variants.length; i++)
            {
                var v = result.product.variants[i];
                if (v && (v.available === true || v.available === 'true'))
                {
                    vid = v.id;
                    break;
                }
            }

            if (!vid)
            {
                vid = result.product.variants[0].id;
            }
        }

        cb(vid);
    })
    .fail(function()
    {
        cb(null);
    });
}

function WishlistAddVariantToCart(variantId, $btn)
{
    if (!variantId)
    {
        WishlistRemoveLoadingClassDelayed($btn);
        return;
    }

    addCartWellEasy('id=' + variantId + '&quantity=1');

    $('body').addClass('cart-drawer--show');

    WishlistRemoveLoadingClassDelayed($btn);
    wishlistUpdateGridSection();
}

function WishlistRemoveLoadingClassDelayed($btn)
{
    setTimeout(WishlistRemoveLoadingClassBound.bind(null, $btn));
}

function WishlistRemoveLoadingClassBound($btn)
{
    $btn.removeClass('loading');
}
/* ===================== END Wishlist / Grid Add-to-Cart ===================== */
